import { render, staticRenderFns } from "./KarInterno.vue?vue&type=template&id=2edefb52&scoped=true"
import script from "./KarInterno.vue?vue&type=script&lang=js"
export * from "./KarInterno.vue?vue&type=script&lang=js"
import style0 from "./KarInterno.vue?vue&type=style&index=0&id=2edefb52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edefb52",
  null
  
)

export default component.exports